// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__ezfd9","heading":"Privacy_heading__GoEgG","policy":"Privacy_policy__0huaj","subHeading":"Privacy_subHeading__9VY-S","content":"Privacy_content__sWNPE"};